import React from 'react';
import GlobalStyles from '@mui/material/GlobalStyles';
import { alpha } from '@mui/material/styles';

// TODO: rework after up ag-grid to v33
const AgGridGlobalStyles = () => {
  return (
    <GlobalStyles
      styles={(theme) => ({
        '.ag-theme-dokka': {
          // Filter popup width parity: legacy/tabs menu (workspace) uses
          // `--ag-tab-min-width` (290 in Quartz); the new menu reads
          // `--ag-menu-min-width` (default 181) and applies it ONLY to the
          // inner `.ag-filter-body-wrapper`, leaving the outer popup to hug
          // content. Override the variable here AND apply it to the popup
          // itself — keeps one knob, ensures the outer container is also sized
          // so the popup doesn't visibly jump as async data lands.
          '--ag-menu-min-width': '290px',
          '& .ag-menu.ag-filter-menu': {
            width: 'var(--ag-menu-min-width)',
          },

          '& .ag-simple-filter-body-wrapper > .MuiFormControl-root': {
            marginBottom: 'var(--ag-widget-vertical-spacing)',
          },

          '& .ag-picker-field-wrapper': {
            border: 'solid 1px',
            borderColor: 'var(--ag-border-color)',
          },

          '& input, & .ag-picker-field-wrapper:focus-within, & .ag-checkbox-input-wrapper, & .ag-floating-filter-button-button, & .ag-standard-button':
            {
              boxShadow: 'none',

              '&:focus': {
                borderColor: theme.palette.primary.main,
              },
            },

          '& .ag-popup-editor ': {
            boxShadow: 'none',
          },

          // FOR NOW NOT USED - remove in the future, style for CustomTooltip component
          '& .ag-react-container.ag-tooltip-custom': {
            position: 'absolute',
            pointerEvents: 'none',
            minWidth: 50,
            maxWidth: 300,
            width: 'auto',
            height: 'auto',

            '& .ag-tooltip-custom--content': {
              fontSize: 12,
              backgroundColor: theme.palette.grey[800],
              borderRadius: 4,
              color: theme.palette.common.white,
              padding: theme.spacing(0.5, 1),
              display: 'flex',
              wordBreak: 'break-all',
              width: 'max-content',
            },
          },

          '& .ag-tooltip.ag-cell-tooltip': {
            fontSize: 12,
            borderRadius: 4,
            padding: theme.spacing(0.5, 1),
            display: 'flex',
            wordBreak: 'break-all',
            width: 'max-content',
            minWidth: 50,
            maxWidth: 300,
          },

          '& .ag-root-wrapper': {
            background: 'none',
          },

          '& .ag-header': {
            marginBottom: 10,
            border: 'none',
            background: 'none',
            zIndex: 3, // makes grid header accessible when no-rows-overlay is shown
          },

          '& .ag-header-cell-label': {
            justifyContent: 'center',
          },

          '& .ag-status-bar': {
            borderBottom: 'none',
            borderLeft: 'none',
            borderRight: 'none',
            backgroundColor: 'var(--ag-background-color)',
          },

          '& .ag-body-horizontal-scroll.ag-scrollbar-invisible': {
            pointerEvents: 'all !important',
          },

          // ======== STYLES FOR CELL
          '& .ag-cell, & .ag-header-cell': {
            padding: theme.spacing(0, 2),
            borderTop: '1px solid var(--ag-border-color)',
            borderBottom: '1px solid var(--ag-border-color)',
          },

          '& .ag-header-cell': {
            backgroundColor: 'var(--ag-header-background-color)',

            '&-resize:before': {
              content: '""',
              position: 'absolute',
              zIndex: 1,
              left: 'calc(50% - 1px)',
              width: 2,
              height: '30%',
              top: '35%',
              backgroundColor: theme.palette.grey[300],
            },
          },

          '& .ag-cell': {
            backgroundColor: '#ffffff',
            borderRight: 0,
            borderLeft: 0,

            '&.ag-cell-focus[class*="__SERVICE"]': {
              borderTopColor: 'var(--ag-border-color)',
              borderBottomColor: 'var(--ag-border-color)',
              borderLeftColor: 'transparent',
              borderRightColor: 'transparent',
            },

            '&.ag-cell-range-selected-1:not(.ag-column-hover)': {
              backgroundColor: 'var(--ag-range-selection-background-color ,rgba(122,134,203,.1))',
            },

            '&.ag-cell-range-selected:not(.ag-column-hover)': {
              backgroundColor: 'var(--ag-range-selection-background-color ,rgba(122,134,203,.1))',
            },

            '&.ag-cell-range-selected.ag-cell-range-left.ag-cell-range-right, &.ag-cell-range-selected.ag-cell-range-single-cell':
              {
                border: '1px solid var(--ag-range-selection-border-color)',
              },

            '&.cell-negative-number': {
              // Minus must be always on the left side DA-4725
              unicodeBidi: 'plaintext',
            },
          },

          // ======== STYLES FOR ROW
          '& .ag-row-level-0': {
            maxHeight: 48,
            background: 'none',
            border: 'none',

            '&.ag-row-hover': {
              background: 'none',

              '&:before': {
                display: 'none',
              },

              '& .ag-cell': {
                backgroundColor: 'var(--ag-row-hover-color)',
              },
            },
          },

          '& .ag-row-selected': {
            backgroundColor: 'transparent',

            '&:before': {
              display: 'none',
            },

            '& .ag-cell': {
              backgroundColor: 'var(--ag-selected-row-background-color)',
            },
          },

          '& .ag-body-viewport.ag-layout-normal': {
            overflowX: 'scroll',
            overflowY: 'scroll',
          },

          '& ::-webkit-scrollbar': {
            webkitAppearance: 'none',
            width: 8,
            height: 8,
          },

          '& .ag-body-vertical-scroll.ag-scrollbar-invisible': {
            position: 'static', // os behaviour when scrollbar is hidden and show when start scrolling
          },

          // macOS / overlay-scrollbar OSes report 0-width scrollbars, so AG Grid enters its
          // "invisible scrollbar" mode and auto-hides the fake scroll (default opacity: 0, shown
          // only while .ag-scrollbar-scrolling / -active). scrollbarWidth / alwaysShow*Scroll do
          // NOT override that — only this does. Force both axes permanently visible so the scroll
          // affordance never disappears (DA-19531). Single `&`: the scroll elements are descendants
          // of .ag-theme-dokka, not themselves themed (the earlier `& &` never matched).
          '& .ag-body-horizontal-scroll.ag-scrollbar-invisible.ag-apple-scrollbar, & .ag-body-vertical-scroll.ag-scrollbar-invisible.ag-apple-scrollbar': {
            opacity: 1,
            visibility: 'visible',
          },

          '& ::-webkit-scrollbar-thumb': {
            borderRadius: 4,
            backgroundColor: alpha(theme.palette.common.black, 0.5),
            boxShadow: `0 0 1px ${alpha(theme.palette.common.white, 0.5)}`,
          },

          '& .ag-center-cols-viewport::-webkit-scrollbar': {
            display: 'none !important',
          },

          '& .ag-checkbox-cell, & .ag-checkbox-edit': {
            justifyContent: 'center',
            paddingLeft: 0,
            paddingRight: 0,
          },

          // DA-19422: the pagination row spans edge to edge — AG's own `spacing * 3` inset is
          // dropped so the row is flush with whatever gutters the host page already provides.
          '& .ag-paging-panel': {
            paddingInline: 0,
          },

          '& .ag-paging-panel .ag-paging-page-size': {
            '& .ag-label': {
              display: 'none',
            },

            '& .ag-picker-field-wrapper': {
              border: '1px solid var(--ag-border-color)',
            },
          },

          '& .ag-pinned-left-cols-container': {
            '& .ag-cell-last-left-pinned': {
              boxShadow: `5px 0px 5px -6px ${alpha(theme.palette.common.black, 0.5)} /* @noflip */`,
            },
          },

          '& .ag-pinned-right-cols-container': {
            '& .ag-cell-first-right-pinned': {
              boxShadow: `-5px 0px 5px -6px ${alpha(theme.palette.common.black, 0.5)} /* @noflip */`,
            },
          },

          '& .ag-menu-option': {
            fontWeight: 400,
          },
        },
      })}
    />
  );
};

export default AgGridGlobalStyles;
